
import Logger from "./Logger";

export class ExternalCallbackRegistry {
	public static HOOK_INIT = "init";
	public static HOOK_SET_LOCALE = "setLocale";
	public static HOOK_GET_PANEL_ATTRIBUTES = "getPanelAttributes";
	public static HOOK_CHANGE_ROUTE = "changeRoute";
	private static KEY = "__callbacks";

	private registered: { [hook: string]: Array<((data: any) => any)>; } = {};

	public static init() {
		if (!window[ExternalCallbackRegistry.KEY]) {
			window[ExternalCallbackRegistry.KEY] = new ExternalCallbackRegistry();
		}
	}

	public static get(): ExternalCallbackRegistry {
		if (!window[ExternalCallbackRegistry.KEY]) {
			ExternalCallbackRegistry.init();
		}
		return window[ExternalCallbackRegistry.KEY];
	}

	public on(hook: string, callback: (data: any) => any) {
		if (typeof callback === 'function') {
			if (!this.registered[hook]) {
				this.registered[hook] = [];
			}
			this.registered[hook].push(callback);
		} else {
			Logger.error("Invalid callback supplied to ExternalCallbackRegistry for hook %s", hook);
		}
	}

	/**
	 * call all registered callbacks for a particular hook
	 * @param hook event hook name
	 * @param data data object to pass to each external callback
	 * @param callback (optional) callback for each return value
	 */
	public callAll(hook: string, data: any, callback?: (result: any) => void) {
		if (this.registered[hook] && this.registered[hook].length) {
			for (const ec of this.registered[hook]) {
				try {
					const d = ec(data);
					if (typeof callback === 'function') {
						callback(d);
					}
				} catch (e) {
					console.error(e);
					Logger.error("Error in callback");
				}
			}
		}
	}

	/**
	 * call the first registered callback for a hook, if available
	 * @param hook event hook name
	 * @param data data object to pass to each external callback
	 */
	public callFirst(hook: string, data: any): any {
		try {
			return (this.registered[hook] && this.registered[hook].length) ? this.registered[hook][0](data) : undefined;
		} catch(e) {
			return null;
		}
	}
}



// WEBPACK FOOTER //
// ./src/core/util/IExternalCallback.ts